import React from 'react';
import {
  Box,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import PropTypes from 'prop-types';

/**
 * VersionFilter Component
 * Filter section for selecting template version
 */
const VersionFilter = ({
  selectedVersion,
  versions,
  feedbackCount,
  onVersionChange,
}) => {
  return (
    <Box
      sx={{
        mb: 2,
        p: 2,
        backgroundColor: 'grey.50',
        borderRadius: 1,
        display: 'flex',
        gap: 2,
        alignItems: 'center',
        flexWrap: 'wrap',
        border: '1px solid',
        borderColor: 'grey.200',
      }}
    >
      {/* Version Filter */}
      <FormControl size="small" sx={{ minWidth: 150 }}>
        <InputLabel>Version</InputLabel>
        <Select
          value={selectedVersion}
          label="Version"
          onChange={onVersionChange}
        >
          <MenuItem value="all">All Versions</MenuItem>
          {versions.map(version => (
            <MenuItem
              key={version.version_number || version.version}
              value={version.version_number || version.version}
            >
              Version {version.version_number || version.version}
              {version.status && ` (${version.status})`}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {/* Feedback Count */}
      <Typography variant="body2" color="text.secondary">
        {feedbackCount} feedback{' '}
        {selectedVersion !== 'all' ? `for version ${selectedVersion}` : ''}
      </Typography>
    </Box>
  );
};

VersionFilter.propTypes = {
  selectedVersion: PropTypes.string.isRequired,
  versions: PropTypes.array.isRequired,
  feedbackCount: PropTypes.number.isRequired,
  onVersionChange: PropTypes.func.isRequired,
};

export default VersionFilter;
